import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { RouteObject } from 'react-router-dom'
import ReportWAFList from './components/List'
import ReportWafCreate from './components/New'
import ReportWafUpdate from './components/Update'
import ReportWafHistory from './components/History'
import PipelineDashboard from './components/Pipeline'

const ReportWAFModule: RouteObject = {
    path: 'technical/report',
    children: [
        {
            path: '',
            element: <ReportWAFList />,
        },
        {
            path: 'pipeline',
            element: <PipelineDashboard />,
        },
        {
            path: 'new',
            element: <ReportWafCreate />,
        },
        {
            path: ':id/edit',
            element: <ReportWafUpdate />,
        },
        {
            path: ':id/history',
            element: <ReportWafHistory />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ReportWAFModule
